import { useCallback } from 'react';

import { useDialogs } from '@work4all/components';

import { Position } from '@work4all/models/lib/Classes/Position.entity';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { MaskDialogOverlay } from '../../../entity-picker/MaskDialogOverlay';
import { ErpObject } from '../types';

export const useErpMask = (allData: ErpObject[], onRefetch: () => void) => {
  const dialogs = useDialogs();
  const openMask = useCallback(
    (position: Position) => {
      const bzObj = allData.find((x) =>
        x.positionList.some((y) => y.id === position.id)
      );
      const dialog = dialogs.open(MaskDialogOverlay, {
        id: bzObj.id,
        entity: Entities.contract,
        onAfterSave: onAfterSave,
        close: closeMaskOverlay,
      });
      function closeMaskOverlay() {
        dialogs.close(dialog.id);
      }
      function onAfterSave() {
        closeMaskOverlay();
        onRefetch();
      }
    },
    [dialogs, allData, onRefetch]
  );

  return openMask;
};
